export const service = {
    labels: {
        service: "Service",
        services: "Services",
        services_categories: "Services / Categories",
        services_group: "Services - Categories",
        services_edit: "Services - Edit Category",
        category_edit: "Edit Category",
        categories: "Categories",
        item_edit: "Edit Service",
        category: "Category",
        benefits: "Benefits",
    },
    placeholders: {
    },
    modals: {
        titles: {
            service_add: "Add Service",
            service_del: "Delete Service",
            category_add: "Add Category",
            category_del: "Delete Category",
            benefit_add: "Add Benefit",
            benefit_del: "Delete Benefit",
        },
        messages: {
            category_del: "Do you want to remove the category <strong>{name}</strong>?<br/>This will remove all services in this group.",
            qualification_del: "Do you want to remove the service <strong>{name}</strong>?<br/>This action cannot be undone!",
            benefit_del: "Do you want to remove the benefit <strong>{name}</strong>?<br/>This action cannot be undone!",
        },
    },
    texts: {
    },
};